/* 
 	* 指令下发组件 
 	* 描述：InsGT740AlarmClockModeSet指令下发
 	* 创建时间：2017-07-27 
 	* 创建人：baixx 
*/
<template>
	<div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<div class="col-sm-2"></div>
				<label class="col-sm-6 control-label t_left"> <span class="red pr5px">*</span> 每天指定唤醒时段（1~12个）</label>
			</div>
			<div class="form-group t_left">
				<div class="col-sm-2"></div>
			    <div class="col-sm-9 text-center">
			        <input type="text" class="form-control" v-model="alarmClockTime" placeholder="HH:mm,HH:mm,HH:mm,HH:mm,HH:mm..."> 
			    </div>
		   </div>
		    <div class="form-group">
				<label class="col-sm-3 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px pr10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		</form>
   </div>	
</template>
<script>
	export default {
		name: "InsGT740AlarmClockModeSet",
		data() {
			return {
				alarmClockTime:"",              //闹钟时段
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.alarmClockTime = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			compareFunc(t1,t2){
				let h1 = t1.split(':')[0]
				let m1 = t1.split(':')[1]
				let h2 = t2.split(':')[0]
				let m2 = t2.split(":")[1]
			//	console.log(Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)))
				return Number(h2)*60 + Number(m2) - (Number(h1)*60 + Number(m1)) >= 5
			},
			nextClick(){
				let resStr = this.alarmClockTime.replace(/\s*/g, "")  //去掉空格
				let durationStr = /^((?:(?:0|1)\d|2[0-3]):[0-5]\d\,){0,11}(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(resStr)
				if(durationStr){
					let arr = resStr.split(',');
					if(arr.length >= 2){
						for(let i = 0,l = arr.length; i < l - 1; i ++){
							let compare = this.compareFunc(arr[i],arr[i + 1])
							if(compare){
								this.alertMsg = ''
							}else{
								this.alertMsg = '请从小到大输入时段，且间隔不小于5分钟'
								return
							}
						}
					}
					this.alertMsg = ''
				}else{
					this.alertMsg = '唤醒时段填写不正确'
					return
				}
				let arr = ["SETPRM","MODE",4,this.alarmClockTime]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsGT740AlarmClockModeSet.vue?f6e7e27a